// Core
import { 
  Route, 
  Switch, 
  Redirect, 
  useRouteMatch, 
} from 'react-router-dom';

// Chakra imports
import { 
  Box,
} from '@chakra-ui/react';

// Components
import UserPurchase from './UserPurchase';
import UserPurchasesDetails from './UserPurchasesDetails';

function PosTransactions(props) {
  const { path } = useRouteMatch();

  return (
    <>
      <Box>
        <Switch>
          <Route path={`${path}/:id`} render={() => <UserPurchasesDetails/>}/>
          <Route path={`${path}`} render={() => <UserPurchase/>}/>
          <Redirect from={`${path}*`} to={`${path}`} />
        </Switch>
      </Box>
    </>
  );
}

export default PosTransactions;